module.exports = __webpack_public_path__ + "static/media/icon-add-card.5cc3f4d5.svg";